import { COVER_IMAGE_ALLOWED_TYPES, COVER_IMAGE_MAX_BYTES } from './eventFormConstants';

const isAllowedCoverImageType = (file) => {
  if (!(file instanceof File)) return false;
  if (COVER_IMAGE_ALLOWED_TYPES.has(file.type)) return true;
  return /\.(jpe?g|png)$/i.test(file.name);
};

export const validateCoverImageFileSize = (file) => {
  if (!(file instanceof File)) {
    return { valid: true };
  }

  if (file.size > COVER_IMAGE_MAX_BYTES) {
    return {
      valid: false,
      message: 'Cover image must be 10 MB or smaller.',
    };
  }

  return { valid: true };
};

const validateCoverImageFileType = (file) => {
  if (!(file instanceof File)) {
    return { valid: true };
  }

  if (!isAllowedCoverImageType(file)) {
    return {
      valid: false,
      message: 'Cover image must be JPG, JPEG, or PNG.',
    };
  }

  return { valid: true };
};

export const validateCoverImageFile = (file) => {
  const typeResult = validateCoverImageFileType(file);
  if (!typeResult.valid) return typeResult;
  return validateCoverImageFileSize(file);
};
